import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import emoji from '../Icons/smile.png';
import '../Styles/Thanks.css';
import ButtonPay from '../Components/PayButton';
import undo from '../Icons/undo.png';

const Thanks = ()=> {
    useEffect(()=>{
        localStorage.setItem("carrito", JSON.stringify([]))
    }, [])
    return(
        <div className="thanks">
            <Header title="El Rancho"/>
            <div className="thanksBody">
                <div className="thanksDivTitle">
                    <h2 className="thanksTitle">¡Muchas gracias!</h2>
                </div>
                <div className="thanksDivEmote">
                    <img src={emoji} alt=":)"/>
                </div>
                <div className="thanksDivText">
                    <div className="textContainer">
                       <p className="thanksText" >Te llamaremos <br className="thanksHidden"/>
                        por telefono para decirte <br/> 
                        los detalles del pedido. <br/>
                        <br/>
                        Gracias por confiar en <br className="thanksHidden"/> 
                        nosotros y esperamos <br className="thanksHidden"/>
                        que la comida sea de tu <br className="thanksHidden"/>
                        agrado. <br/>
                        <br/>
                        ¡Que aproveche!</p> 
                    </div>
                </div>
                <div className="buttonReturn">
                    <ButtonPay img={undo} text="Página principal" link="/" go={true}/>
                </div>
            </div>
            <Footer/>
        </div>
    )
}

export default Thanks;